import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { userService } from '../../services/user/UserService';
import { Icon, validators, AbstractFormComponent } from 'front-onceforall-core';
import TextField from '@material-ui/core/TextField';
import { captureError } from '../../utils/log';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ChangeEmail extends AbstractFormComponent {
  getFormData() {
    return {
      email: '',
      emailConfirmation: ''
    };
  }
  getFormValidators() {
    return {
      email: [validators.requiredValidator, validators.emailValidator],
      emailConfirmation: [validators.requiredValidator, validators.emailValidator, value => value !== this.state.formData.email && 'error.emailConfirmation']
    };
  }
  handleSubmitCallback() {
    userService.requestUpdateEmail(this.props.userId, this.state.formData.email).then(() => {
      this.props.actions.addSuccess(/*#__PURE__*/_jsx(Translate, {
        value: "user.emailChanged",
        newEmail: this.state.formData.email
      }));
      this.props.onClose();
    }).catch(error => {
      captureError('userService.requestUpdateEmail', error);
      this.props.actions.addError(/*#__PURE__*/_jsx(Translate, {
        value: "error.generic"
      }));
      this.props.onClose();
    });
  }
  render() {
    return /*#__PURE__*/_jsxs("form", {
      onSubmit: this.handleSubmit,
      children: [/*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: 'user.changeEmailAddress'
        })
      }), /*#__PURE__*/_jsx(TextField, {
        label: this.getFieldLabel('user.email', true),
        error: this.isOnError('email'),
        helperText: this.helperText('email'),
        id: "email",
        name: "email",
        value: this.state.formData.email,
        onChange: this.handleChange('email'),
        autoFocus: true
      }), /*#__PURE__*/_jsx(TextField, {
        label: this.getFieldLabel('user.emailConfirmation', true),
        error: this.isOnError('emailConfirmation'),
        helperText: this.helperText('emailConfirmation'),
        id: "emailConfirmation",
        name: "emailConfirmation",
        value: this.state.formData.emailConfirmation,
        onChange: this.handleChange('emailConfirmation')
      }), /*#__PURE__*/_jsxs("div", {
        className: "actions col-12 inline-container space-between",
        children: [/*#__PURE__*/_jsxs("button", {
          type: "button",
          className: "large secondary inline-container",
          onClick: this.props.onClose,
          "data-id": "cancel",
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "action.cancel"
          }), /*#__PURE__*/_jsx(Icon, {
            icon: "go-back"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          className: "large cta inline-container",
          type: "submit",
          disabled: this.state.submitting,
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "action.confirm"
          }), /*#__PURE__*/_jsx(Icon, {
            icon: this.state.submitting ? 'loader' : 'check'
          })]
        })]
      })]
    });
  }
}
ChangeEmail.propTypes = {
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};
export default ChangeEmail;